import React, { Component } from "react";
import { sortableContainer } from "react-sortable-hoc";
import arrayMove from "array-move";

const SortableContainer = sortableContainer(({ children }) => {
  return <div>{children}</div>;
});

class SortableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.list,
    };
  }

  componentDidUpdate(props) {
    if (props.list.length !== this.props.list.length) {
      this.setState({ items: this.props.list });
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    let sortedItems = arrayMove(this.props.list, oldIndex, newIndex);
    this.setState({ items: sortedItems });
    this.props.sortedList(sortedItems);
  };

  render() {
    return (
      <SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
        {this.state.items.map(this.props.renderItem)}
      </SortableContainer>
    );
  }
}

export default SortableList;
